<div class="slider-container">
    <!--  <input type="range" class="custom-slider" [min]="min" [max]="max" [value]="value" (input)="onSliderChange($event)" />-->
    <input type="range" class="custom-slider"
           [min]="min - 1"
           [max]="max"
           [value]="value !== null ? value : min - 1"
           [disabled]="readOnly"
           (input)="onSliderChange($event)"
           (change)="onChange($event)"
           [class.no-score]="value === null"
           [style.background]="sliderBarColor" />
    <div class="slider-thumb"
         [style.left.%]="getThumbPosition()"
         (mousedown)="startDrag($event)">
        {{ value !== null ? value : '?' }}
    </div>

    <!-- Tick Marks -->
    <div class="tick-marks">
        <!--<span class="tick" style="left: 2%">0</span>-->
        <!--<span class="tick" style="left: 50%">10</span>-->
        <span class="tick" style="left: 102%">20</span>
    </div>
</div>
